import withPageHandler from '~pricing/hocs/withPageHandler';
import PricingSummary from './Summary';
import PricingDetails from './Details';
import EnterprisePage from './Enterprise';
import EducationalPage from './Educational';

import GROW2792Summary from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/Summary';
import GROW2792Details from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/Details';
import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import { Page } from '../types';
import { ROOT_PRICING_ROUTE } from '~shared/constants/pricing';

/**
 * Please note <domain>/pricing/details is a valid route that renders the team details page
 * We should always take into account this route in all our experiments and use cases.
 */
export default function GetPricingPage(): Page[] {
  const { priceExperiment } = usePricingExperiments();
  const isPnPRefresh =
    priceExperiment.hasAssignment &&
    (priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment ||
      priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment2);

  const PricingPage = isPnPRefresh ? GROW2792Summary : PricingSummary;
  const DetailsPage = isPnPRefresh ? GROW2792Details : PricingDetails;

  return [
    {
      component: withPageHandler(PricingPage),
      paths: [
        ROOT_PRICING_ROUTE,
        `${ROOT_PRICING_ROUTE}/`,
        `${ROOT_PRICING_ROUTE}/upgrade/`,
        `${ROOT_PRICING_ROUTE}/upgrade/quickview/`,
        `${ROOT_PRICING_ROUTE}/:canonicalPath(individual|teams)`,
      ],
    },
    {
      component: withPageHandler(EnterprisePage),
      paths: [`${ROOT_PRICING_ROUTE}/:canonicalPath(enterprise)/:subPath(details)?`],
    },
    {
      component: withPageHandler(DetailsPage),
      paths: [`${ROOT_PRICING_ROUTE}/:canonicalPath(details|individual|teams)?/:subPath(details)`],
    },
    {
      component: withPageHandler(EducationalPage),
      paths: [`${ROOT_PRICING_ROUTE}/:canonicalPath(educational)`],
    },
  ];
}
